/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addMenuCategory } from '../fn/menu-v-2/add-menu-category';
import { AddMenuCategory$Params } from '../fn/menu-v-2/add-menu-category';
import { addMenuItem } from '../fn/menu-v-2/add-menu-item';
import { AddMenuItem$Params } from '../fn/menu-v-2/add-menu-item';
import { addMenuSubcategory } from '../fn/menu-v-2/add-menu-subcategory';
import { AddMenuSubcategory$Params } from '../fn/menu-v-2/add-menu-subcategory';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { MenuCategoriesDto as DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto } from '../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-categories-dto';
import { MenuCategoryDto as DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto } from '../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-category-dto';
import { MenuItemDto as DigiworkMaitreDPosDtoMenuItemsMenuItemDto } from '../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-item-dto';
import { MenuItemsDto as DigiworkMaitreDPosDtoMenuItemsMenuItemsDto } from '../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-items-dto';
import { MenuSubcategoriesDto as DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto } from '../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategories-dto';
import { MenuSubcategoryDto as DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto } from '../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategory-dto';
import { getAllMenuItems } from '../fn/menu-v-2/get-all-menu-items';
import { GetAllMenuItems$Params } from '../fn/menu-v-2/get-all-menu-items';
import { getMenuCategoriesForAreaLayout } from '../fn/menu-v-2/get-menu-categories-for-area-layout';
import { GetMenuCategoriesForAreaLayout$Params } from '../fn/menu-v-2/get-menu-categories-for-area-layout';
import { getMenuCategoriesForVenue } from '../fn/menu-v-2/get-menu-categories-for-venue';
import { GetMenuCategoriesForVenue$Params } from '../fn/menu-v-2/get-menu-categories-for-venue';
import { getMenuCategoryById } from '../fn/menu-v-2/get-menu-category-by-id';
import { GetMenuCategoryById$Params } from '../fn/menu-v-2/get-menu-category-by-id';
import { getMenuItem } from '../fn/menu-v-2/get-menu-item';
import { GetMenuItem$Params } from '../fn/menu-v-2/get-menu-item';
import { getMenuItemsForMenuCategory } from '../fn/menu-v-2/get-menu-items-for-menu-category';
import { GetMenuItemsForMenuCategory$Params } from '../fn/menu-v-2/get-menu-items-for-menu-category';
import { getMenuItemsForMenuSubcategory } from '../fn/menu-v-2/get-menu-items-for-menu-subcategory';
import { GetMenuItemsForMenuSubcategory$Params } from '../fn/menu-v-2/get-menu-items-for-menu-subcategory';
import { getMenuSubcategoriesByMenuCategoryId } from '../fn/menu-v-2/get-menu-subcategories-by-menu-category-id';
import { GetMenuSubcategoriesByMenuCategoryId$Params } from '../fn/menu-v-2/get-menu-subcategories-by-menu-category-id';
import { getMenuSubcategoryById } from '../fn/menu-v-2/get-menu-subcategory-by-id';
import { GetMenuSubcategoryById$Params } from '../fn/menu-v-2/get-menu-subcategory-by-id';
import { getMostOrderedItems_1 } from '../fn/menu-v-2/get-most-ordered-items-1';
import { GetMostOrderedItems_1$Params } from '../fn/menu-v-2/get-most-ordered-items-1';
import { removeMenuCategory } from '../fn/menu-v-2/remove-menu-category';
import { RemoveMenuCategory$Params } from '../fn/menu-v-2/remove-menu-category';
import { removeMenuItem } from '../fn/menu-v-2/remove-menu-item';
import { RemoveMenuItem$Params } from '../fn/menu-v-2/remove-menu-item';
import { removeMenuSubcategory } from '../fn/menu-v-2/remove-menu-subcategory';
import { RemoveMenuSubcategory$Params } from '../fn/menu-v-2/remove-menu-subcategory';
import { updateMenuCategory } from '../fn/menu-v-2/update-menu-category';
import { UpdateMenuCategory$Params } from '../fn/menu-v-2/update-menu-category';
import { updateMenuItem_1 } from '../fn/menu-v-2/update-menu-item-1';
import { UpdateMenuItem_1$Params } from '../fn/menu-v-2/update-menu-item-1';
import { updateMenuSubcategory } from '../fn/menu-v-2/update-menu-subcategory';
import { UpdateMenuSubcategory$Params } from '../fn/menu-v-2/update-menu-subcategory';

@Injectable({ providedIn: 'root' })
export class MenuV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMenuCategoriesForVenue()` */
  static readonly GetMenuCategoriesForVenuePath = '/api/menu-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuCategoriesForVenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuCategoriesForVenue$Response(params?: GetMenuCategoriesForVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>> {
    return getMenuCategoriesForVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuCategoriesForVenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuCategoriesForVenue(params?: GetMenuCategoriesForVenue$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto> {
    return this.getMenuCategoriesForVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>): DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto => r.body)
    );
  }

  /** Path part for operation `addMenuCategory()` */
  static readonly AddMenuCategoryPath = '/api/menu-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addMenuCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMenuCategory$Response(params?: AddMenuCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>> {
    return addMenuCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addMenuCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMenuCategory(params?: AddMenuCategory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto> {
    return this.addMenuCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>): DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto => r.body)
    );
  }

  /** Path part for operation `getMenuCategoryById()` */
  static readonly GetMenuCategoryByIdPath = '/api/menu-categories/{menuCategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuCategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuCategoryById$Response(params: GetMenuCategoryById$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>> {
    return getMenuCategoryById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuCategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuCategoryById(params: GetMenuCategoryById$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto> {
    return this.getMenuCategoryById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>): DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto => r.body)
    );
  }

  /** Path part for operation `updateMenuCategory()` */
  static readonly UpdateMenuCategoryPath = '/api/menu-categories/{menuCategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMenuCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMenuCategory$Response(params: UpdateMenuCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>> {
    return updateMenuCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMenuCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMenuCategory(params: UpdateMenuCategory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto> {
    return this.updateMenuCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>): DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto => r.body)
    );
  }

  /** Path part for operation `removeMenuCategory()` */
  static readonly RemoveMenuCategoryPath = '/api/menu-categories/{menuCategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeMenuCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMenuCategory$Response(params: RemoveMenuCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeMenuCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeMenuCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMenuCategory(params: RemoveMenuCategory$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeMenuCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `getMenuSubcategoriesByMenuCategoryId()` */
  static readonly GetMenuSubcategoriesByMenuCategoryIdPath = '/api/menu-categories/{menuCategoryId}/menu-subcategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuSubcategoriesByMenuCategoryId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuSubcategoriesByMenuCategoryId$Response(params: GetMenuSubcategoriesByMenuCategoryId$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto>> {
    return getMenuSubcategoriesByMenuCategoryId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuSubcategoriesByMenuCategoryId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuSubcategoriesByMenuCategoryId(params: GetMenuSubcategoriesByMenuCategoryId$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto> {
    return this.getMenuSubcategoriesByMenuCategoryId$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto>): DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto => r.body)
    );
  }

  /** Path part for operation `addMenuSubcategory()` */
  static readonly AddMenuSubcategoryPath = '/api/menu-categories/{menuCategoryId}/menu-subcategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addMenuSubcategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMenuSubcategory$Response(params: AddMenuSubcategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>> {
    return addMenuSubcategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addMenuSubcategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMenuSubcategory(params: AddMenuSubcategory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto> {
    return this.addMenuSubcategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>): DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto => r.body)
    );
  }

  /** Path part for operation `getMenuSubcategoryById()` */
  static readonly GetMenuSubcategoryByIdPath = '/api/menu-categories/{menuCategoryId}/menu-subcategories/{menuSubcategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuSubcategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuSubcategoryById$Response(params: GetMenuSubcategoryById$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>> {
    return getMenuSubcategoryById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuSubcategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuSubcategoryById(params: GetMenuSubcategoryById$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto> {
    return this.getMenuSubcategoryById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>): DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto => r.body)
    );
  }

  /** Path part for operation `updateMenuSubcategory()` */
  static readonly UpdateMenuSubcategoryPath = '/api/menu-categories/{menuCategoryId}/menu-subcategories/{menuSubcategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMenuSubcategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMenuSubcategory$Response(params: UpdateMenuSubcategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>> {
    return updateMenuSubcategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMenuSubcategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMenuSubcategory(params: UpdateMenuSubcategory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto> {
    return this.updateMenuSubcategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>): DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto => r.body)
    );
  }

  /** Path part for operation `removeMenuSubcategory()` */
  static readonly RemoveMenuSubcategoryPath = '/api/menu-categories/{menuCategoryId}/menu-subcategories/{menuSubcategoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeMenuSubcategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMenuSubcategory$Response(params: RemoveMenuSubcategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeMenuSubcategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeMenuSubcategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMenuSubcategory(params: RemoveMenuSubcategory$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeMenuSubcategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `getAllMenuItems()` */
  static readonly GetAllMenuItemsPath = '/api/menu-categories/menu-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMenuItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMenuItems$Response(params?: GetAllMenuItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>> {
    return getAllMenuItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMenuItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMenuItems(params?: GetAllMenuItems$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto> {
    return this.getAllMenuItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>): DigiworkMaitreDPosDtoMenuItemsMenuItemsDto => r.body)
    );
  }

  /** Path part for operation `addMenuItem()` */
  static readonly AddMenuItemPath = '/api/menu-categories/menu-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addMenuItem()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  addMenuItem$Response(params?: AddMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>> {
    return addMenuItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addMenuItem$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  addMenuItem(params?: AddMenuItem$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuItemsMenuItemDto> {
    return this.addMenuItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>): DigiworkMaitreDPosDtoMenuItemsMenuItemDto => r.body)
    );
  }

  /** Path part for operation `getMenuItem()` */
  static readonly GetMenuItemPath = '/api/menu-categories/menu-items/{menuItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItem$Response(params: GetMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>> {
    return getMenuItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItem(params: GetMenuItem$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuItemsMenuItemDto> {
    return this.getMenuItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>): DigiworkMaitreDPosDtoMenuItemsMenuItemDto => r.body)
    );
  }

  /** Path part for operation `updateMenuItem_1()` */
  static readonly UpdateMenuItem_1Path = '/api/menu-categories/menu-items/{menuItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMenuItem_1()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMenuItem_1$Response(params: UpdateMenuItem_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>> {
    return updateMenuItem_1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMenuItem_1$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMenuItem_1(params: UpdateMenuItem_1$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuItemsMenuItemDto> {
    return this.updateMenuItem_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>): DigiworkMaitreDPosDtoMenuItemsMenuItemDto => r.body)
    );
  }

  /** Path part for operation `removeMenuItem()` */
  static readonly RemoveMenuItemPath = '/api/menu-categories/menu-items/{menuItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeMenuItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMenuItem$Response(params: RemoveMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeMenuItem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeMenuItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMenuItem(params: RemoveMenuItem$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeMenuItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `getMenuItemsForMenuCategory()` */
  static readonly GetMenuItemsForMenuCategoryPath = '/api/menu-categories/{menuCategoryId}/menu-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuItemsForMenuCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItemsForMenuCategory$Response(params: GetMenuItemsForMenuCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>> {
    return getMenuItemsForMenuCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuItemsForMenuCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItemsForMenuCategory(params: GetMenuItemsForMenuCategory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto> {
    return this.getMenuItemsForMenuCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>): DigiworkMaitreDPosDtoMenuItemsMenuItemsDto => r.body)
    );
  }

  /** Path part for operation `getMenuItemsForMenuSubcategory()` */
  static readonly GetMenuItemsForMenuSubcategoryPath = '/api/menu-categories/{menuCategoryId}/menu-subcategories/{menuSubcategoryId}/menu-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuItemsForMenuSubcategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItemsForMenuSubcategory$Response(params: GetMenuItemsForMenuSubcategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>> {
    return getMenuItemsForMenuSubcategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuItemsForMenuSubcategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuItemsForMenuSubcategory(params: GetMenuItemsForMenuSubcategory$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto> {
    return this.getMenuItemsForMenuSubcategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>): DigiworkMaitreDPosDtoMenuItemsMenuItemsDto => r.body)
    );
  }

  /** Path part for operation `getMenuCategoriesForAreaLayout()` */
  static readonly GetMenuCategoriesForAreaLayoutPath = '/api/menu-categories/layouts/{servingAreaId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMenuCategoriesForAreaLayout()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuCategoriesForAreaLayout$Response(params: GetMenuCategoriesForAreaLayout$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>> {
    return getMenuCategoriesForAreaLayout(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMenuCategoriesForAreaLayout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMenuCategoriesForAreaLayout(params: GetMenuCategoriesForAreaLayout$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto> {
    return this.getMenuCategoriesForAreaLayout$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto>): DigiworkMaitreDPosDtoMenuCategoriesMenuCategoriesDto => r.body)
    );
  }

  /** Path part for operation `getMostOrderedItems_1()` */
  static readonly GetMostOrderedItems_1Path = '/api/menu-categories/{venueId}/menu-items/most-ordered-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMostOrderedItems_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMostOrderedItems_1$Response(params: GetMostOrderedItems_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>> {
    return getMostOrderedItems_1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMostOrderedItems_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMostOrderedItems_1(params: GetMostOrderedItems_1$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto> {
    return this.getMostOrderedItems_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>): DigiworkMaitreDPosDtoMenuItemsMenuItemsDto => r.body)
    );
  }

}
